module.exports = __webpack_public_path__ + "img/service-resource01.0f040842.jpg";